module.exports = __webpack_public_path__ + "static/media/customerServiceimg4.d1652e1f.png";